import { AttributionData } from './AttributionData';

export class SignupPayload {
  constructor(
    _businessName: string,
    _businessCategoryId: number | null,
    _businessSizeId: number | null,
    _contactTelephone: string,
    _countryCode: string,
    _couponCode: string,
    _currencyCode: string,
    _email: string,
    _firstName: string,
    _lastName: string,
    _password: string,
    _previousSystemId: number | null,
    _timeZoneLocaleId: string,
    _recaptchaResponse: string,
    _attributionData: AttributionData,
    _marketingConsentGranted: boolean,
    _consentTemplateId: number | null,
  ) {
    this.businessName = _businessName;
    this.businessCategoryId = _businessCategoryId;
    this.businessSizeId = _businessSizeId;
    this.contactTelephone = _contactTelephone;
    this.countryCode = _countryCode;
    this.couponCode = _couponCode;
    this.currencyCode = _currencyCode;
    this.email = _email;
    this.firstName = _firstName;
    this.lastName = _lastName;
    this.password = _password;
    this.previousSystemId = _previousSystemId;
    this.timeZoneLocaleId = _timeZoneLocaleId;
    this.recaptchaResponse = _recaptchaResponse;
    this.attributionData = _attributionData;
    this.marketingConsentGranted = _marketingConsentGranted;
    this.consentTemplateId = _consentTemplateId;
  }

  businessName: string;
  businessCategoryId: number | null;
  businessSizeId: number | null;
  contactTelephone: string;
  countryCode: string;
  couponCode: string;
  currencyCode: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  previousSystemId: number | null;
  timeZoneLocaleId: string;
  recaptchaResponse: string;
  attributionData: AttributionData;
  marketingConsentGranted: boolean;
  consentTemplateId: number | null;
}
